export const getComputedStyleForSpan = (span) => {
	const style = window.getComputedStyle(span);
	return {
		fill: style.color,
		fontWeight: style.fontWeight,
		fontStyle: style.fontStyle,
		fontFamily: style.fontFamily,
		fontSize: style.fontSize,
		letterSpacing: style.letterSpacing,
		textDecoration: style.textDecoration,
		textTransform: style.textTransform,
	};
};

export function splitTextToLines(spans, maxWidth) {
	const container = document.createElement('div');
	container.style.position = 'absolute';
	container.style.visibility = 'hidden';
	container.style.pointerEvents = 'none';
	// container.style.whiteSpace = 'pre';
	// container.style.display = 'flex';
	// container.style.flexWrap = 'wrap';
	container.style.width = `${maxWidth + 1}px`;
	document.body.appendChild(container);

	const words = [];
	const styles = [];

	const applyTextTransform = (text, style) => {
		switch ((style.textTransform || '').toLowerCase()) {
			case 'uppercase':
				return text.toUpperCase();
			case 'lowercase':
				return text.toLowerCase();
			case 'capitalize':
				return text.replace(/\b\w/g, (c) => c.toUpperCase());
			default:
				return text;
		}
	};

	spans.forEach((span) => {
		const parts = span.text.match(/(\S+|\s)/g);
		parts.forEach((part) => {
			words.push(part);
			styles.push(span.style);
		});
	});

	const lines = [];
	let line = [];
	let lineStyles = [];
	for (let i = 0; i < words.length; i++) {
		const word = applyTextTransform(words[i], styles[i]);
		const style = styles[i];

		const tempLine = [...line, word];
		const tempLineStyles = [...lineStyles, style];
		container.innerHTML = '';
		tempLine.forEach((w, idx) => {
			const span = document.createElement('span');
			span.textContent = w;
			const s = tempLineStyles[idx];
			for (let key in s) {
				span.style[key] = s[key];
			}
			span.style.color = s['fill'];
			container.appendChild(span);
		});

		line.push(word);
		lineStyles.push(style);
	}
	const groupRows = groupByRows(container);

	if (line.length) {
		groupRows.forEach((item, i) => {
			const word = [];
			const style = [];
			item.forEach((el, ind, arr) => {
				word.push(el.textContent);
				style.push(getComputedStyleForSpan(el));
			});
			lines[i] = { words: word, styles: style };
		});
	}

	document.body.removeChild(container);
	return lines;
}

//! id generation function
const idArray = [];
let counterId = 0;

export function generateId() {
	if (idArray.includes(counterId)) {
		counterId++;
		return generateId();
	}

	idArray.push(counterId);
	return counterId;
}

export function groupByRows(container) {
	const children = Array.from(container.children);
	if (!children.length) return [];

	const lines = [];
	let currentLine = [];
	let lastTop = null;

	children.forEach((child) => {
		const rect = child.getBoundingClientRect();
		if (lastTop === null || Math.abs(rect.top - lastTop) < 1) {
			currentLine.push(child);
		} else {
			lines.push(currentLine);
			currentLine = [child];
		}
		lastTop = rect.top;
	});

	if (currentLine.length) lines.push(currentLine);

	return lines;
}

//! get size of css
export function getCssVariablePxValue(element, varName) {
	if (!(element instanceof Element)) {
		throw new Error('getCssVariablePxValue: element is not a valid DOM Element');
	}

	const style = window.getComputedStyle(element);
	const value = style.getPropertyValue(varName).trim();

	const temp = document.createElement('div');
	temp.style.position = 'absolute';
	temp.style.visibility = 'hidden';
	temp.style.marginBlockStart = value;
	document.body.appendChild(temp);

	const px = parseFloat(window.getComputedStyle(temp).marginBlockStart);

	document.body.removeChild(temp);
	return px;
}
